export default "__VITE_ASSET__48503a39__"